export default "assets/images/icons/instagram-9b37e9a2.svg";